<div (click)="onDispatchEvent($event)" [class.has-comment]="params()?.value" class="comment-cell clickable-element" data-cy="grid-engine-comment-cell">
  <mat-icon>comment</mat-icon>
  <span class="comment-total">{{ $safeNavigationMigration(params()?.value) | numberFormat }}</span>
</div>
